"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.getProviderId = void 0;
/* eslint-disable camelcase */
// Higher level cache on top of Manager
var semver_1 = __importDefault(require("semver"));
var chunk_1 = __importDefault(require("lodash/chunk"));
var errors_1 = require("@ledgerhq/errors");
var currencies_1 = require("../currencies");
var Manager_1 = __importDefault(require("../api/Manager"));
var provider_1 = require("./provider");
exports.getProviderId = provider_1.getProviderId;
var ICONS_FALLBACK = {
    bitcoin_testnet: "bitcoin"
};
var oldAppsInstallDisabled = [
    "Crypto.com Chain",
    "ZenCash",
    "Ripple",
    "Ontology",
    "Zcoin",
];
var canHandleInstall = function (app) {
    return !oldAppsInstallDisabled.includes(app.name) &&
        !(0, currencies_1.listCryptoCurrencies)(true, true).some(function (coin) {
            return coin.managerAppName &&
                coin.terminated &&
                coin.managerAppName.toLowerCase() === app.name.toLowerCase();
        });
};
var CacheAPI = {
    // TODO: Move to new ManagerAPI
    // When ready, the manager api will return an icon url instead of a name
    getIconUrl: function (icon) {
        var icn = ICONS_FALLBACK[icon] || icon;
        return "https://cdn.live.ledger.com/icons/".concat(icn, ".png");
    },
    getFirmwareVersion: function (firmware) {
        return firmware.name.replace("-osu", "");
    },
    // TO BE CONFIRMED – LL-2568
    firmwareUpdateNeedsLegacyBlueResetInstructions: function (deviceInfo, deviceModelId) {
        return deviceModelId === "blue" &&
            semver_1["default"].lt(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "2.1.1");
    },
    // TO BE CONFIRMED – LL-2564
    firmwareUpdateWillResetSeed: function (deviceInfo, deviceModelId, _firmware) {
        return deviceModelId === "blue" &&
            semver_1["default"].lt(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "2.1.1");
    },
    firmwareUpdateWillUninstallApps: function (_deviceInfo, _deviceModelId) { return true; },
    // true for all? TO BE CONFIRMED – LL-2710
    firmwareUpdateRequiresUserToUninstallApps: function (deviceModel, deviceInfo) {
        return deviceModel === "nanoS" &&
            semver_1["default"].lte(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "1.4.2");
    },
    firmwareUnsupported: function (deviceModel, deviceInfo) {
        return deviceModel === "nanoS" &&
            semver_1["default"].lt(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "1.3.0");
    },
    formatHashName: function (input, deviceModel, deviceInfo) {
        var shouldEllipsis = deviceModel && deviceInfo
            ? deviceModel === "blue" ||
                (deviceModel === "nanoS" &&
                    semver_1["default"].lt(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "1.6.0"))
            : true;
        var shouldSplit = deviceInfo && deviceModel
            ? (deviceModel === "nanoS" &&
                semver_1["default"].gte(semver_1["default"].valid(semver_1["default"].coerce(deviceInfo.version)) || "", "1.6.0")) ||
                deviceModel === "nanoX"
            : false;
        var hash = (input || "").toUpperCase();
        var splitLength = deviceModel === "nanoS" ? 16 : 17;
        return shouldSplit
            ? (0, chunk_1["default"])(hash.split(""), splitLength).map(function (item) { return item.join(""); })
            : hash.length > 8 && shouldEllipsis
                ? ["".concat(hash.slice(0, 4), "...").concat(hash.substr(-4))]
                : [hash];
    },
    canHandleInstall: canHandleInstall,
    getLatestFirmwareForDevice: function (deviceInfo) { return __awaiter(void 0, void 0, void 0, function () {
        var mcusPromise, deviceVersion, osu, seFirmwareVersion, final, mcus, currentMcuVersion, shouldFlashMCU;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    mcusPromise = Manager_1["default"].getMcus();
                    return [4 /*yield*/, Manager_1["default"].getDeviceVersion(deviceInfo.targetId, (0, provider_1.getProviderId)(deviceInfo))];
                case 1:
                    deviceVersion = _a.sent();
                    if (!deviceInfo.isOSU) return [3 /*break*/, 3];
                    return [4 /*yield*/, Manager_1["default"].getCurrentOSU({
                            deviceId: deviceVersion.id,
                            provider: (0, provider_1.getProviderId)(deviceInfo),
                            version: deviceInfo.version
                        })];
                case 2:
                    osu = _a.sent();
                    return [3 /*break*/, 6];
                case 3: return [4 /*yield*/, Manager_1["default"].getCurrentFirmware({
                        version: deviceInfo.version,
                        deviceId: deviceVersion.id,
                        provider: (0, provider_1.getProviderId)(deviceInfo)
                    })];
                case 4:
                    seFirmwareVersion = _a.sent();
                    return [4 /*yield*/, Manager_1["default"].getLatestFirmware({
                            current_se_firmware_final_version: seFirmwareVersion.id,
                            device_version: deviceVersion.id,
                            provider: (0, provider_1.getProviderId)(deviceInfo)
                        })];
                case 5:
                    // Fetch next possible firmware
                    osu = _a.sent();
                    _a.label = 6;
                case 6:
                    if (!osu) {
                        return [2 /*return*/, null];
                    }
                    return [4 /*yield*/, Manager_1["default"].getFinalFirmwareById(osu.next_se_firmware_final_version)];
                case 7:
                    final = _a.sent();
                    return [4 /*yield*/, mcusPromise];
                case 8:
                    mcus = _a.sent();
                    currentMcuVersion = mcus.find(function (mcu) { return mcu.name === deviceInfo.mcuVersion; });
                    if (!currentMcuVersion)
                        throw new errors_1.UnknownMCU();
                    shouldFlashMCU = !final.mcu_versions.includes(currentMcuVersion.id);
                    return [2 /*return*/, {
                            final: final,
                            osu: osu,
                            shouldFlashMCU: shouldFlashMCU
                        }];
            }
        });
    }); },
    // get list of apps for a given deviceInfo
    getAppsList: function (deviceInfo, isDevMode, // TODO getFullListSortedCryptoCurrencies can be a local function.. too much dep for now
    getFullListSortedCryptoCurrencies) {
        if (isDevMode === void 0) { isDevMode = false; }
        if (getFullListSortedCryptoCurrencies === void 0) { getFullListSortedCryptoCurrencies = function () { return Promise.resolve([]); }; }
        return __awaiter(void 0, void 0, void 0, function () {
            var deviceVersionP, firmwareDataP, applicationsByDeviceP, _a, applicationsList, compatibleAppVersionsList, sortedCryptoCurrencies, filtered, sortedCryptoApps;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        console.warn("deprecated: use @ledgerhq/live-common/src/apps/* instead");
                        if (deviceInfo.isOSU || deviceInfo.isBootloader)
                            return [2 /*return*/, Promise.resolve([])];
                        deviceVersionP = Manager_1["default"].getDeviceVersion(deviceInfo.targetId, (0, provider_1.getProviderId)(deviceInfo));
                        firmwareDataP = deviceVersionP.then(function (deviceVersion) {
                            return Manager_1["default"].getCurrentFirmware({
                                deviceId: deviceVersion.id,
                                version: deviceInfo.version,
                                provider: (0, provider_1.getProviderId)(deviceInfo)
                            });
                        });
                        applicationsByDeviceP = Promise.all([
                            deviceVersionP,
                            firmwareDataP,
                        ]).then(function (_a) {
                            var _b = __read(_a, 2), deviceVersion = _b[0], firmwareData = _b[1];
                            return Manager_1["default"].applicationsByDevice({
                                provider: (0, provider_1.getProviderId)(deviceInfo),
                                current_se_firmware_final_version: firmwareData.id,
                                device_version: deviceVersion.id
                            });
                        });
                        return [4 /*yield*/, Promise.all([
                                Manager_1["default"].listApps(),
                                applicationsByDeviceP,
                                getFullListSortedCryptoCurrencies(),
                            ])];
                    case 1:
                        _a = __read.apply(void 0, [_b.sent(), 3]), applicationsList = _a[0], compatibleAppVersionsList = _a[1], sortedCryptoCurrencies = _a[2];
                        filtered = isDevMode
                            ? compatibleAppVersionsList.slice(0)
                            : compatibleAppVersionsList.filter(function (version) {
                                var app = applicationsList.find(function (e) { return e.id === version.app; });
                                if (app) {
                                    return app.category !== 2;
                                }
                                return false;
                            });
                        sortedCryptoApps = [];
                        // sort by crypto first
                        sortedCryptoCurrencies.forEach(function (crypto) {
                            var app = filtered.find(function (item) {
                                return item.name.toLowerCase() === crypto.managerAppName.toLowerCase();
                            });
                            if (app) {
                                filtered.splice(filtered.indexOf(app), 1);
                                sortedCryptoApps.push(__assign(__assign({}, app), { currency: crypto }));
                            }
                        });
                        return [2 /*return*/, sortedCryptoApps.concat(filtered)];
                }
            });
        });
    }
};
exports["default"] = CacheAPI;
//# sourceMappingURL=index.js.map